import React from "react";



import iconone from '../../assets/images/integrated-process/icon-1.svg';
import icontwo from '../../assets/images/integrated-process/icon-2.svg';
import iconthree from '../../assets/images/integrated-process/icon-3.svg';
import iconfour from '../../assets/images/integrated-process/icon-4.svg';
import iconfive from '../../assets/images/integrated-process/icon-5.svg';
import iconsix from '../../assets/images/integrated-process/icon-6.svg';


const steps = [
  {
    title: "Step 1",
    heading: "Consultation & Concept",
    desc: "Requirement study, layouts, zoning, vastu options.",
    icon: iconone,
  },
  {
    title: "Step 2",
    heading: "3D & Technical Design",
    desc: "Elevation, interiors, structural & MEP coordination.",
    icon: icontwo,
  },
  {
    title: "Step 3",
    heading: "Online Plan Approval",
    desc: "CMDA/DTCP documentation → submission → approval.",
    icon: iconthree,
  },
  {
    title: "Step 4",
    heading: "Turnkey Construction",
    desc: "Structure, MEP, finishes, QC, weekly site updates.",
    icon: iconfour,
  },
  {
    title: "Step 5",
    heading: "Interiors & VR/AR Finalization",
    desc: "Materials & designs confirmed via VR walkthrough.",
    icon: iconfive,
  },
  {
    title: "Step 6",
    heading: "Handover & Tracker Archive",
    desc: "Report, warranty & digital documentation.",
    icon: iconsix,
  }
];

const IntegratedProcess = () => {
  return (
    <div className="steps-container">
      {steps.map((step, index) => (
        <div className="step" key={index}>
          <div className="hex">
            <img src={step.icon} alt={step.heading} />
          </div>

          <h3>{step.title}</h3>
          <h4>{step.heading}</h4>
          <p>{step.desc}</p>

          {/* Arrow logic */}
          {index !== steps.length - 1 && (
            <span
              className={`arrow ${
                index === 3 ? "down" : "right"
              }`}
            >
              {index === 3 ? "⬇" : "➜"}
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default IntegratedProcess;
